module.exports = __webpack_public_path__ + "img/sld_mfm_inv_1_t1_b1_dark.0ddd3d68.svg";